import axios from 'axios'

const adminAPI = {
    // Inbox
    getInbox(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-unread-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    readNotificationStatusByType(data) {
        return new Promise((resolve, reject) => {
            axios.post('read-status-update-by-type', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getNotification(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    readStatusUpdate(data) {
        return new Promise((resolve, reject) => {
            axios.post('read-status-update', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getUnreadNotificationCount(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-unread-notification-count', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteNotification(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    getSupportQuery(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-support-query/' + data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getLogs(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-logs', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    cacheClear() {
        return new Promise((resolve, reject) => {
            axios.get('clear-redis-cache').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    // Newsletters
    getNewsletters(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-subscribe-user-emails-pegination', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getAllNewsletters(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-subscribe-user-emails', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteNewsletter(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-newsletter', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Orders
    getOrders(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-orders', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getOrderDetails(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-order-details', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getInvoices(data) {
        return new Promise((resolve, reject) => {
            axios.post('invoice-list', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    updatePaymentStatus(data) {
        return new Promise((resolve, reject) => {
            axios.post('invoice-status-update', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    // Discount Offer
    addDiscountOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getDiscountOffers(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-offers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    editDiscountOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateDiscountOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('update-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteDiscountOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    statusDiscountOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    // Documents
    addDocument(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-documents', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getDocuments(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-documents', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    editDocument(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-document', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateDocument(data) {
        return new Promise((resolve, reject) => {
            axios.post('update-documents', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    statusDocument(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-document', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteDocument(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-document', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // General Settings
    addGeneralSetting(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-general-setting', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getGeneralSetting(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-general-setting', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateGeneralSetting(data) {
        return new Promise((resolve, reject) => {
            axios.post('update-producer-general-setting', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Booking Settings
    addCancellationFee(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-booking-cancel-fee', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },



    getPriceTax() {
        return new Promise((resolve, reject) => {
            axios.post('get-tax').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateTax(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-tax', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getOffers(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-offers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    editOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('update-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    statusOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteOffer(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-offer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Provider
    /*getProviders(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-providers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },*/
    getProducers(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-producers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getGeneralSettings(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-general-settings', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getProducerStatus(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer-profile-status', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    activeProducerCategory(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-producer-categories/' + data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getProducerDetails(data) {
        return new Promise((resolve, reject) => {
            axios.get('producer-details/' + data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    /*addProvider(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-provider', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },*/
    addProducer(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-producer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    /*editProvider(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-provider', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },*/
    editProducer(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-producer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    /*updateProvider(data) {
        return new Promise((resolve, reject) => {
            axios.post('update-provider', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },*/
    updateProducer(data) {
        return new Promise((resolve, reject) => {
            axios.post('update-producer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    /*statusProvider(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-providers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },*/
    statusProducer(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-producers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    /*deleteProvider(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-providers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },*/
    deleteProducer(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-producers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    /*getProviderRooms(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-provider-property', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },*/
    getProducerProducts(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-producer-products', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getAllProducts(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-all-producer-products', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getProviderRoomBookings(data) {
        return new Promise((resolve, reject) => {
            axios.post('/booking-list', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Customer
    getCustomers(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-customers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getCustomerDetails(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-customer-details/' + data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteCustomer(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-customer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    // addProvider(data) {
    //     return new Promise((resolve, reject) => {
    //         axios.post('add-provider', data).then((response) => {
    //             resolve(response.data)
    //         }, (error) => {
    //             reject(error)
    //         })
    //     })
    // },
    // editProvider(data) {
    //     return new Promise((resolve, reject) => {
    //         axios.post('edit-provider', data).then((response) => {
    //             resolve(response.data)
    //         }, (error) => {
    //             reject(error)
    //         })
    //     })
    // },
    // updateProvider(data) {
    //     return new Promise((resolve, reject) => {
    //         axios.post('update-provider', data).then((response) => {
    //             resolve(response.data)
    //         }, (error) => {
    //             reject(error)
    //         })
    //     })
    // },
    statusCustomer(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-customer', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getGeneralSettings(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-dealer-general-settings', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getAllCustomers(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-all-customers', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Room Category
    getRoomCategories(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-categories', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addRoomCategory(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-category",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editRoomCategory(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-category', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateRoomCategory(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "update-category",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    statusRoomCategory(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-categories', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteRoomCategory(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-categories', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // PRODUCT APIs
    getProducts(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-products', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    statusProduct(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-product', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    /* IN USE */
    activeCategory() {
        return new Promise((resolve, reject) => {
            axios.get('active-categories').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Badges
    getBadges(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-badges', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addBadge(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-badge', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    editBadge(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-badge', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateBadge(data) {
        return new Promise((resolve, reject) => {
            axios.post('update-badge', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    statusBadge(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-badge', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteBadge(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-badge', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getActiveBadges() {
        return new Promise((resolve, reject) => {
            axios.get('active-badges').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Product Certificates
    getCertificateList(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-certifications', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addCertificate(data) {
        return new Promise((resolve, reject) => {
            axios.post('add-certification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    editCertificate(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-certification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateCertificate(data) {
        return new Promise((resolve, reject) => {
            axios.post('update-certification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    statusCertificate(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-certification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteCertificate(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-certification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getActiveCertificates() {
        return new Promise((resolve, reject) => {
            axios.get('active-certifications').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    //payment options
    getPaymentOptions() {
        return new Promise((resolve, reject) => {
            axios.get('active-payment-options').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    //get product features
    getProductFeatures() {
        return new Promise((resolve, reject) => {
            axios.get('active-product-features').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    //get product features
    getDeliveryOptions() {
        return new Promise((resolve, reject) => {
            axios.get('active-delivery-options').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    getStates() {
        return new Promise((resolve, reject) => {
            axios.get('active-states').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    //payment options
    getProductInfo() {
        return new Promise((resolve, reject) => {
            axios.get('active-product-informations').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    //get product certificates
    getProductCertificates() {
        return new Promise((resolve, reject) => {
            axios.get('active-certifications').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    //get product certificates
    getProductUnits() {
        return new Promise((resolve, reject) => {
            axios.get('active-units').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Product Information
    getInfoList(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-product-informations', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addProductInfo(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-product-information",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editProductInfo(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-product-information', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateProductInfo(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "update-product-information",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    statusProductInfo(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-product-information', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteProductInfo(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-product-information', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Product Features
    getFeatureList(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-product-features', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addProductFeature(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-product-feature",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editProductFeature(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-product-feature', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateProductFeature(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "update-product-feature",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    statusProductFeature(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-product-feature', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteProductFeature(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-product-feature', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    //Delivery Options
    getDeliveryOptionList(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-delivery-options', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addDeliveryOption(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-delivery-option",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editDeliveryOption(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-delivery-option', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateDeliveryOption(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "update-delivery-option",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    statusDeliveryOption(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-delivery-option', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteDeliveryOption(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-delivery-option', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Payment Options
    getOptionList(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-payment-options', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addPaymentOption(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-payment-option",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editPaymentOption(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-payment-option', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updatePaymentOption(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "update-payment-option",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    statusPaymentOption(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-payment-option', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deletePaymentOption(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-payment-option', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Blog Category
    getBlogCategories(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-blog-categories', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addBlogCategory(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-blog-category",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editBlogCategory(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-blog-category', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateBlogCategory(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "update-blog-category",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    statusBlogCategory(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-blog-category', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteBlogCategory(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-blog-category', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Blog
    getBlogs(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-blogs', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    activeBlogCategories(data) {
        return new Promise((resolve, reject) => {
            axios.get('active-blog-categories', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addBlog(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-blog",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editBlog(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-blog', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateBlog(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "update-blog",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    statusBlog(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-blogs', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteBlog(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-blogs', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // CMS
    addAboutContent(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-about-us-content",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editAboutContent() {
        return new Promise((resolve, reject) => {
            axios.post('edit-about-us-content').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // FAQ
    getFaqs(data) {
        return new Promise((resolve, reject) => {
            axios.post('get-faqs', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addFaq(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "add-faq",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    editFaq(data) {
        return new Promise((resolve, reject) => {
            axios.post('edit-faq', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateFaq(data) {
        return new Promise((resolve, reject) => {
            axios
                .request({
                    method: "POST",
                    url: "update-faq",
                    mimeType: "multipart/form-data",
                    data: data,
                }).then((response) => {
                    resolve(response.data)
                }, (error) => {
                    reject(error)
                })
        })
    },
    statusFaq(data) {
        return new Promise((resolve, reject) => {
            axios.post('status-faq', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteFaq(data) {
        return new Promise((resolve, reject) => {
            axios.post('delete-faq', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    dashboardNotification(data) {
        return new Promise((resolve, reject) => {
            axios.post('/dashboard', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    createSlug(data) {
        return new Promise((resolve, reject) => {
            axios.post('create-slug',data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    cancellationInvoice(data) {
        return new Promise((resolve, reject) => {
            axios.post("cancellation-invoice", data).then(
              (response) => {
                resolve(response.data);
              },
              (error) => {
                reject(error);
              }
            );
        })
    },
}

export default adminAPI
